import { useContext, useEffect, useRef, useState } from "react"
import { schoolContext } from "../providers/school.provider"
import { getCourtLessonsOnDate } from "../utils/firestore.utils"

const NONE = []

// Le lezioni di un campo in un giorno, di tutti i maestri del circolo. Si
// leggono una volta per campo e per giorno, e restano finché il modulo è
// aperto: tornando sul campo di prima non si rilegge niente. Senza campo
// (`court` null, o il campo 0) non si legge niente.
function useCourtLessonsOnDate(date, court) {
	const { selectedSchool } = useContext(schoolContext)
	const courtNumber = court?.courtNumber
	const hasCourt = Boolean(date && selectedSchool && court?.courtsSport) && Number(courtNumber) !== 0
	const key = hasCourt ? `${selectedSchool}|${date}|${court.courtsSport}|${courtNumber}` : null

	const cache = useRef(new Map())
	const [, setRead] = useState(0)

	useEffect(() => {
		if (!key || cache.current.has(key)) return
		cache.current.set(key, NONE)
		getCourtLessonsOnDate(selectedSchool, court, date)
			.then(found => {
				cache.current.set(key, found)
				setRead(count => count + 1)
			})
			// senza rete, o senza l'indice: l'avviso del campo non c'è, e il
			// modulo funziona lo stesso. Si riprova alla prossima apertura.
			.catch(error => {
				cache.current.delete(key)
				console.warn("Le lezioni del campo non si leggono:", error)
			})
		// la chiave dice già tutto quello da cui dipende la lettura
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key])

	return key ? (cache.current.get(key) ?? NONE) : NONE
}

export default useCourtLessonsOnDate
